export default __webpack_public_path__ + "static/570-abf24ebd9ec6903ad389db26dfc53a94.gif";